import api from './api';

const submoduleService = {
  getAllSubmodules: async (params = {}) => {
    const response = await api.get('/submodules', { params });
    return response.data;
  },

  getSubmoduleById: async (id) => {
    const response = await api.get(`/submodules/${id}`);
    return response.data;
  },

  getSubmoduleStats: async () => {
    const response = await api.get('/submodules/stats');
    return response.data;
  },

  createSubmodule: async (data) => {
    const response = await api.post('/submodules', data);
    return response.data;
  },

  updateSubmodule: async (id, data) => {
    const response = await api.put(`/submodules/${id}`, data);
    return response.data;
  },

  deleteSubmodule: async (id) => {
    const response = await api.delete(`/submodules/${id}`);
    return response.data;
  }
};

export default submoduleService;
